import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { completeMagicLink } from '../lib/auth';

type Status = 'pending' | 'error';

export default function LoginCallback() {
  const navigate = useNavigate();
  const [status, setStatus] = useState<Status>('pending');
  const [message, setMessage] = useState<string>('');
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    completeMagicLink(window.location.href)
      .then(() => navigate('/'))
      .catch((e: Error) => {
        setStatus('error');
        setMessage(
          e.message === 'not-a-magic-link'
            ? 'Länken är inte giltig.'
            : 'Inloggningen kunde inte slutföras. Begär en ny länk.',
        );
      });
  }, [navigate]);

  if (status === 'pending') {
    return (
      <div className="max-w-md mx-auto mt-16 text-center" aria-busy="true">
        <p role="status" aria-live="polite">
          Loggar in…
        </p>
      </div>
    );
  }
  return (
    <div className="max-w-md mx-auto mt-16 bg-white rounded-lg shadow p-6">
      <h1 className="text-xl font-bold mb-2 text-navy">Inloggning misslyckades</h1>
      <p className="text-sm">{message}</p>
      <a href="/login" className="text-sky underline">
        Försök igen
      </a>
    </div>
  );
}
